import { Divider, Stack, Typography } from '@mui/material'
import { IconButton } from 'utoniq-ui'

import { Organism, OrganismFrame } from '@/core/architecture'

type HeaderProps = {
  title: string
  onClose: () => void
  back?: boolean
}

export const Header: Organism<HeaderProps> = ({ title, onClose, back }) => (
  <OrganismFrame>
    <Stack direction="row" sx={{ height: 55, px: 3 }} alignItems="center">
      <IconButton.Back
        size="small"
        onClick={onClose}
        sx={{ visibility: !back ? 'hidden' : undefined }}
      />
      <Typography variant="h6" align="center" width="100%">
        {title}
      </Typography>
      <IconButton.Close
        size="small"
        onClick={onClose}
        sx={{ visibility: back ? 'hidden' : undefined }}
      />
    </Stack>
    <Divider />
  </OrganismFrame>
)
